/**
 * Link to num for gallery component
 *
 * @enum LINKTO
 * @type {{NONE: string, MEDIA: string, ATTACHMENT: string}}
 */
const LINKTO = {
  NONE: 'none',
  MEDIA: 'media',
  ATTACHMENT: 'attachment',
};

export { LINKTO };
